export const mockSelectedOffers = {
  data: [
    {
      'offer_name': '$3 OFF XYZ DOG FOOD',
      'items': '3',
      'avg_sales_per_store_week': 34,
      'print': 'N/A',
      'display': 'N/A',
      'est_sales_qty_during_promo_lift': '685 (34%)',
      'est_sales_dollars_during_promo': '$3700',
      'est_retail_savings_during_promo': '$1234',
      'est_psp_funding': '25',
      'est_vendor_funding': '$1445 (51%)',
      'total_est_unit_sales_lift': '12-22.3%',
      'total_est_margin_gain': '1456',
      'total_est_margin_lift': '23%',
      'est_direct_lift': '21%',
      'est_halo_lift': '1%',
      'est_affinity_pull_lift': '1%',
      'est_cannibalization_loss': '0%',
      'est_pull_forward_loss': '0%'
    },
    {
      'offer_name': '$3 OFF XYZ DOG FOOD',
      'items': '3',
      'avg_sales_per_store_week': 34,
      'print': 'N/A',
      'display': 'N/A',
      'est_sales_qty_during_promo_lift': '685 (34%)',
      'est_sales_dollars_during_promo': '$3700',
      'est_retail_savings_during_promo': '$1234',
      'est_psp_funding': '25',
      'est_vendor_funding': '$1445 (51%)',
      'total_est_unit_sales_lift': '12-22.3%',
      'total_est_margin_gain': '1456',
      'total_est_margin_lift': '23%',
      'est_direct_lift': '21%',
      'est_halo_lift': '1%',
      'est_affinity_pull_lift': '1%',
      'est_cannibalization_loss': '0%',
      'est_pull_forward_loss': '0%'
    },
    {
      'offer_name': '$3 OFF XYZ DOG FOOD',
      'items': '3',
      'avg_sales_per_store_week': 34,
      'print': 'N/A',
      'display': 'N/A',
      'est_sales_qty_during_promo_lift': '685 (34%)',
      'est_sales_dollars_during_promo': '$3700',
      'est_retail_savings_during_promo': '$1234',
      'est_psp_funding': '25',
      'est_vendor_funding': '$1445 (51%)',
      'total_est_unit_sales_lift': '12-22.3%',
      'total_est_margin_gain': '1456',
      'total_est_margin_lift': '23%',
      'est_direct_lift': '21%',
      'est_halo_lift': '1%',
      'est_affinity_pull_lift': '1%',
      'est_cannibalization_loss': '0%',
      'est_pull_forward_loss': '0%'
    },
    {
      'offer_name': '$4 OFF XYZ CAT FOOD',
      'items': '5',
      'avg_sales_per_store_week': 23,
      'print': 'N/A',
      'display': 'N/A',
      'est_sales_qty_during_promo_lift': '456 (34%)',
      'est_sales_dollars_during_promo': '$3700',
      'est_retail_savings_during_promo': '$876',
      'est_psp_funding': '25',
      'est_vendor_funding': '$1165 (52%)',
      'total_est_unit_sales_lift': '23-45%',
      'total_est_margin_gain': '876',
      'total_est_margin_lift': '22%',
      'est_direct_lift': '19%',
      'est_halo_lift': '3%',
      'est_affinity_pull_lift': '1%',
      'est_cannibalization_loss': '-1%',
      'est_pull_forward_loss': '0%'
    },
    {
      'offer_name': '$5 OFF XYZ DOG FOOD',
      'items': '7',
      'avg_sales_per_store_week': 13,
      'print': 'N/A',
      'display': 'N/A',
      'est_sales_qty_during_promo_lift': '786 (43%)',
      'est_sales_dollars_during_promo': '$4000',
      'est_retail_savings_during_promo': '$1097',
      'est_psp_funding': '25',
      'est_vendor_funding': '$1534 (53%)',
      'total_est_unit_sales_lift': '45-56.7%',
      'total_est_margin_gain': '-98',
      'total_est_margin_lift': '19%',
      'est_direct_lift': '16%',
      'est_halo_lift': '4%',
      'est_affinity_pull_lift': '1%',
      'est_cannibalization_loss': '-2%',
      'est_pull_forward_loss': '0%'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/selected-offers-list/mock.js